import { createTheme } from '@mui/material/styles';
// import { CssBaseline } from '@mui/material';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
  typography: {
    fontFamily: "'Bebas Neue', sans-serif",
  },
});

export const GlobalStyles = () => (
  <style>
    {`
      @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap');
      .property {
        background-image: radial-gradient(circle at center center, rgba(217, 217, 217, 0.05) 0%, rgba(217, 217, 217, 0.05) 15%, rgba(187, 187, 187, 0.05) 15%, rgba(187, 187, 187, 0.05) 34%, rgba(158, 158, 158, 0.05) 34%, rgba(158, 158, 158, 0.05) 51%, rgba(207, 207, 207, 0.05) 51%, rgba(207, 207, 207, 0.05) 75%, rgba(118, 118, 118, 0.05) 75%, rgba(118, 118, 118, 0.05) 89%, rgba(138, 138, 138, 0.05) 89%, rgba(138, 138, 138, 0.05) 100%), radial-gradient(circle at center center, rgb(240, 240, 240) 0%, rgb(240, 240, 240) 6%, rgb(240, 240, 240) 6%, rgb(240, 240, 240) 12%, rgb(240, 240, 240) 12%, rgb(240, 240, 240) 31%, rgb(240, 240, 240) 31%, rgb(240, 240, 240) 92%, rgb(240, 240, 240) 92%, rgb(240, 240, 240) 97%, rgb(240, 240, 240) 97%, rgb(240, 240, 240) 100%);
        background-size: 42px 42px;
        background-attachment: fixed;
    }
    
    .fillOutPage {
        background-image: radial-gradient(circle at center center, rgba(217, 217, 217, 0.05) 0%, rgba(217, 217, 217, 0.05) 15%, rgba(187, 187, 187, 0.05) 15%, rgba(187, 187, 187, 0.05) 34%, rgba(158, 158, 158, 0.05) 34%, rgba(158, 158, 158, 0.05) 51%, rgba(207, 207, 207, 0.05) 51%, rgba(207, 207, 207, 0.05) 75%, rgba(118, 118, 118, 0.05) 75%, rgba(118, 118, 118, 0.05) 89%, rgba(138, 138, 138, 0.05) 89%, rgba(138, 138, 138, 0.05) 100%), radial-gradient(circle at center center, rgb(240, 240, 240) 0%, rgb(240, 240, 240) 6%, rgb(240, 240, 240) 6%, rgb(240, 240, 240) 12%, rgb(240, 240, 240) 12%, rgb(240, 240, 240) 31%, rgb(240, 240, 240) 31%, rgb(240, 240, 240) 92%, rgb(240, 240, 240) 92%, rgb(240, 240, 240) 97%, rgb(240, 240, 240) 97%, rgb(240, 240, 240) 100%);
        background-size: 42px 42px;
        height: 100%;
    }
      .branddesc {
        font-family: 'Bebas Neue', sans-serif;
      }

      .aspect-ratio-4-3 {
        height: 0;
        aspect-ratio: 4/3;
      }

      .tra {
        border: none;
        outline: none;
        background-color: transparent;
        cursor: not-allowed;
        color: inherit;
        font-size: inherit;
      }

      .DetailPic {
        width: 16rem;
        height: 11rem;
        position: absolute;
        right: 5rem;
        top: 9rem;
      }

      .pnewpolicy:hover {
        text-decoration: underline !important;
        color: black !important;
        background-color: rgb(219, 238, 243) !important;
      }

      .cursor-no-drop:hover {
        cursor: no-drop;
      }

      .pay {
        background-image: repeating-linear-gradient(135deg, rgba(240, 240, 240, 0.02) 0px, rgba(240, 240, 240, 0.02) 21px, rgba(224, 224, 224, 0.02) 21px, rgba(224, 224, 224, 0.02) 42px, rgba(208, 208, 208, 0.02) 42px, rgba(208, 208, 208, 0.02) 63px, rgba(192, 192, 192, 0.02) 63px, rgba(192, 192, 192, 0.02) 84px, rgba(175, 175, 175, 0.02) 84px, rgba(175, 175, 175, 0.02) 105px, rgba(159, 159, 159, 0.02) 105px, rgba(159, 159, 159, 0.02) 126px, rgba(143, 143, 143, 0.02) 126px, rgba(143, 143, 143, 0.02) 147px, rgba(127, 127, 127, 0.02) 147px, rgba(127, 127, 127, 0.02) 168px), repeating-linear-gradient(45deg, rgba(232, 232, 232, 0.02) 0px, rgba(232, 232, 232, 0.02) 21px, rgba(209, 209, 209, 0.02) 21px, rgba(209, 209, 209, 0.02) 42px, rgba(185, 185, 185, 0.02) 42px, rgba(185, 185, 185, 0.02) 63px, rgba(162, 162, 162, 0.02) 63px, rgba(162, 162, 162, 0.02) 84px, rgba(138, 138, 138, 0.02) 84px, rgba(138, 138, 138, 0.02) 105px, rgba(115, 115, 115, 0.02) 105px, rgba(115, 115, 115, 0.02) 126px, rgba(91, 91, 91, 0.02) 126px, rgba(91, 91, 91, 0.02) 147px, rgba(68, 68, 68, 0.02) 147px, rgba(68, 68, 68, 0.02) 168px), linear-gradient(90deg, #ffffff, #ffffff);
      }

      .buy {
        position: relative;
        transition: all 0.3s ease-in-out;
      }

      .buy:hover {
        transform: scale(1.01);
        border-color: #fff9;
      }

      .buy:hover::before {
        animation: shine 1.5s ease-out infinite;
      }

      .buy::before {
        content: "";
        position: absolute;
        width: 100px;
        height: 100%;
        background-image: linear-gradient(
          120deg,
          rgba(255, 255, 255, 0) 30%,
          rgba(255, 255, 255, 0.8),
          rgba(255, 255, 255, 0) 70%
        );
        top: 0;
        left: -100px;
        opacity: 0;
        animation: shine 1.5s ease-out infinite;
        z-index: 1;
      }

      @keyframes shine {
        0% { left: -100px; }
        60% { left: 100%; }
        to { left: 100%; }
      }

      @media (max-width: 768px) {
        .someClass {
          // Responsive styles here
        }
      }

      @media (max-width: 480px) {
        .someClass {
          // Responsive styles here
        }
      }
    `}
  </style>
);

export default theme;
